module.exports = __webpack_public_path__ + "img/big.dd2b04a0.jpg";